import { Component, OnInit, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardApiService } from 'src/app/core/services/api/dashboard-api.service';
import { Case } from 'src/app/shared/models/cases/case';
import { Client, ClientLite } from 'src/app/shared/models/clients/client';
import { CaseSession } from 'src/app/shared/models/hearings/caseSession';
import { SearchParams } from 'src/app/shared/models/searchParams';
import { forkJoin } from 'rxjs';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { FileSummaryModalComponent } from 'src/app/shared/file-summary-modal/file-summary-modal.component';
import { ClientSummaryModalComponent } from 'src/app/shared/client-summary-modal/client-summary-modal.component';
import { Router } from '@angular/router';
import { TimesheetEntry } from 'src/app/shared/models/timesheet/timesheetEntry';
import { CaseLite } from 'src/app/shared/models/cases/caseLite';
import { FilesApiService } from 'src/app/core/services/api/files-api.service';
import { ClientsApiService } from 'src/app/core/services/api/clients-api.service';
import { DashboardData } from 'src/app/shared/models/dashboardData';
import { PrintService } from 'src/app/core/services/print.service';
import { InvoiceSearchParams, InvoiceStatus } from 'src/app/shared/models/financials/invoice';
import { InvoicesApiService } from 'src/app/core/services/api/invoices-api.service';
import { HearingsApiService } from 'src/app/core/services/api/hearings-api.service';
import { CaseSessionSearchParams } from 'src/app/shared/models/hearings/caseSessionSearchParams';
import { TimesheetApiService } from 'src/app/core/services/api/timesheet-api.service';
import { TimesheetEntrySearchParams } from 'src/app/shared/models/timesheet/timesheetSearchParams';

@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  public loading;
  public newCasesCount = 0;
  public newClientsCount = 0;
  public pendingCasesCount = 0;
  public overdueHearingsCount = 0;
  public overdueTimesheetCount = 0;
  public pendingInvoicesCount = 0;
  public newClients: ClientLite[] = [];
  public overDueHearings: CaseSession[] = [];

  selected = [];

  @ViewChild('hearingsTable') hearingsTable: any;

  constructor(
    private dashboardApi: DashboardApiService,
    private spinner: NgxSpinnerService) {}

  ngOnInit() {
    this.initLoad();
  }

  initLoad() {
    this.loading = true;
    this.spinner.show();
    const initLoad$ = forkJoin([this.dashboardApi.getDashboardData()])
    initLoad$.subscribe({
      next: value => {
        this.handleResults(value[0]);
      }, complete: () => {
        this.spinner.hide();
      }
    });
  }

  handleResults(r: DashboardData) {
    this.newCasesCount = r.count.newCases;
    this.newClientsCount = r.count.clients;
    this.pendingCasesCount = r.count.pendingCases;
    this.overdueTimesheetCount = r.count.timesheet;
    this.pendingInvoicesCount = r.count.invoices;
    this.newClients = r.clients.results;
    this.newClientsCount = r.clients.count;
    this.loading = false;
  }
}